import { render, staticRenderFns } from "./Youtube.vue?vue&type=template&id=1fa4dd4a&"
import script from "./Youtube.vue?vue&type=script&lang=js&"
export * from "./Youtube.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports